import { Meta } from "@/shared/components";
import { Payments } from "@/admin/features/payments";

export function PaymentsPage() {
  return (
    <>
      <Meta title="Платежи" />
      <Payments />
    </>
  );
}
